/**
 * usePayments Hook
 *
 * Fetches payment history for the authenticated tenant.
 */

import {
  useListTenantPaymentsQuery,
  type ListTenantPaymentsQuery,
  type PaymentStatus,
} from '@bloomcode/graphql';
import { useTenantContext } from './useTenantContext';

type Payment = NonNullable<ListTenantPaymentsQuery['listTenantPayments']['data'][number]>;

interface UsePaymentsOptions {
  page?: number;
  limit?: number;
  status?: PaymentStatus;
}

export function usePayments(options: UsePaymentsOptions = {}) {
  const { page = 1, limit = 20, status } = options;
  const { tenantId, isValid } = useTenantContext();

  const { data, loading, error, refetch } = useListTenantPaymentsQuery({
    variables: {
      tenantId: tenantId!,
      page,
      limit,
      ...(status ? { status } : {}),
    },
    skip: !isValid,
    fetchPolicy: 'cache-and-network',
  });

  const payments: Payment[] = data?.listTenantPayments?.data ?? [];
  const pagination = data?.listTenantPayments?.pagination;

  return {
    payments,
    pagination,
    loading,
    error: error ?? null,
    refetch,
  };
}
